import { apiCall, type ApiCallOptions } from "@/config/axiosConfig";
import { z } from "zod";

const isDevelopment = import.meta.env.MODE === "development";

export const zodGuard = <T>(
  schema: z.ZodSchema<T>,
  data: unknown,
): data is T => {
  const result = schema.safeParse(data);

  if (!result.success && isDevelopment) {
    console.group("%cZod Validation Error", "color: red; font-size: 16px;");
    console.info("Validation failed for schema:");
    console.table(
      result.error.errors.map((err) => ({
        path: err.path.join("."),
        message: err.message,
      })),
    );
    console.groupEnd();
  }

  return result.success;
};

export const fetchWithZod = async <T>(
  schema: z.ZodSchema<T>,
  config: ApiCallOptions,
): Promise<T> => {
  const response = await apiCall(config);

  if (zodGuard(schema, response)) {
    return response;
  }

  throw new Error("API response validation failed");
};
